import { render } from "./CourseTypeManage.vue?vue&type=template&id=99d10a78&scoped=true"
import script from "./CourseTypeManage.vue?vue&type=script&lang=js"
export * from "./CourseTypeManage.vue?vue&type=script&lang=js"

import "./CourseTypeManage.vue?vue&type=style&index=0&id=99d10a78&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99d10a78"]])

export default __exports__